const items = document
  .querySelector(".header__inline-menu")
  .querySelectorAll("details");

for (const item of items) {
  let timeout; // To track the delay timer

  // Open the dropdown on mouseover
  item.addEventListener("mouseover", () => {
    clearTimeout(timeout); // Clear any existing timer
    item.setAttribute("open", true);
  });

  // Close the dropdown with a delay on mouseleave
  item.addEventListener("mouseleave", () => {
    timeout = setTimeout(() => {
      item.removeAttribute("open");
    }, 150); // 1.5-millisecond delay
  });
}
